"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EmailShareMenuItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MailOutline = _interopRequireDefault(require("@kyruus/react-ikons/MailOutline"));
var _style = require("./style");
const shareUrl = (url, text) => {
  return `mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`;
};
const EmailShareButton = _ref => {
  let {
    url,
    text,
    showLabel,
    label = 'Email',
    onBeforeClick,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_style.StyledIconLink, (0, _extends2.default)({}, props, {
    href: shareUrl(url, text),
    onClick: onBeforeClick
  }), /*#__PURE__*/_react.default.createElement(_MailOutline.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": "true",
    title: "",
    "data-testid": "mail-svg"
  }), showLabel ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, null, label) : null);
};
const EmailShareMenuItem = _ref2 => {
  let {
    url,
    text,
    showLabel,
    label,
    onClick,
    ...props
  } = _ref2;
  const handleClick = (url, text) => {
    const targetUrl = shareUrl(url, text);
    if (onClick) {
      onClick('email');
    }
    // check for window in case this is ever server-side-rendered
    if (typeof window !== 'undefined') {
      window.location.href = targetUrl;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_style.StyledMenuItem, (0, _extends2.default)({}, props, {
    onClick: () => {
      handleClick(url, text);
    }
  }), /*#__PURE__*/_react.default.createElement(_MailOutline.default, {
    size: _style.ICON_HEIGHT,
    "aria-hidden": "true",
    title: "",
    "data-testid": "mail-svg"
  }), showLabel ? /*#__PURE__*/_react.default.createElement(_style.StyledLabel, null, label) : null);
};
exports.EmailShareMenuItem = EmailShareMenuItem;
EmailShareButton.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * The text that will form the subject line of the e-mail.
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Whether to show the 'email' label or not
   */
  showLabel: _propTypes.default.bool,
  /**
   * Label content
   */
  label: _propTypes.default.node,
  /**
   * Called before the the onClick is executed for the link.
   */
  onBeforeClick: _propTypes.default.func
};
EmailShareMenuItem.propTypes = {
  /**
   * The url of the page you want to share.
   */
  url: _propTypes.default.string.isRequired,
  /**
   * The text that will form the subject line of the e-mail.
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Whether to show the 'Email' label or not
   */
  showLabel: _propTypes.default.bool,
  /**
   * Label content
   */
  label: _propTypes.default.node,
  /**
   * Called before the the onClick is executed for the link.
   */
  onClick: _propTypes.default.func
};
var _default = exports.default = EmailShareButton;
EmailShareMenuItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmailShareMenuItem",
  "props": {
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "The text that will form the subject line of the e-mail.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "showLabel": {
      "description": "Whether to show the 'Email' label or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "label": {
      "description": "Label content",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "onClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};
EmailShareButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmailShareButton",
  "props": {
    "label": {
      "defaultValue": {
        "value": "'Email'",
        "computed": false
      },
      "description": "Label content",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "url": {
      "description": "The url of the page you want to share.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "text": {
      "description": "The text that will form the subject line of the e-mail.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "showLabel": {
      "description": "Whether to show the 'email' label or not",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onBeforeClick": {
      "description": "Called before the the onClick is executed for the link.",
      "type": {
        "name": "func"
      },
      "required": false
    }
  }
};